export default {
    url: '/events',
    template: '<events-list></events-list>',
    resolve: {},
    controller () {
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/events/list/index.js